import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import EditForm from "./EditForm";

export default function Edit({ alternate, open, close }) {
  return (
    <div>
      <Modal open={open} close={close} dialogClass="modal-sm">
        <Header>
          <Close close={close} />
          <h4 className="modal-title">Change Alternate Type</h4>
          <EditForm close={close} alternate={alternate} showPartInput={false} />
        </Header>
      </Modal>
    </div>
  );
}

Edit.propTypes = {
  alternate: PropTypes.shape({}).isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Alternates/Edit.jsx